import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { DEVICE_ORIENTATION, DEVICE_TYPE } from '../../constants/resizeConstants'

// Break points defined by media values, make sure these match values defined in the common scss file
// @media (min-width:320px)  { /* smartphones, iPhone, portrait 480x320 phones */ }
// @media (min-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ }
// @media (min-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */ }
// @media (min-width:961px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */ }
// @media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */ }
// @media (min-width:1281px) { /* hi-res laptops and desktops */ }

// const widthToHeightOrientationRatio: number = 0.8 // if width is below this ratio with height then assume portraite

// Interface for resizing
interface IResizeState {
	deviceType: DEVICE_TYPE
	orientation: DEVICE_ORIENTATION
	innerWidth: number
	innerHeight: number
	useMobileLayout: boolean
}

// Initial state
const initialState: IResizeState = {
	deviceType: DEVICE_TYPE.DESKTOP,
	orientation: DEVICE_ORIENTATION.LANDSCAPE,
	innerWidth: 0,
	innerHeight: 0,
	useMobileLayout: false
}

// Slice definition
export const resizeSlice = createSlice({
	name: 'resize',
	initialState,
	reducers: {
		windowResize: (state) => {
			state.innerWidth = window.innerWidth
			// const isPortraite = window.innerWidth < window.innerHeight * widthToHeightOrientationRatio
			const isPortraite = window.innerWidth < window.innerHeight
			state.orientation = isPortraite ? DEVICE_ORIENTATION.PORTRAITE : DEVICE_ORIENTATION.LANDSCAPE

			if (window.innerWidth > 960) {
				state.deviceType = DEVICE_TYPE.DESKTOP
			} else if (window.innerWidth > 640) {
				if (isPortraite) {
					state.deviceType = DEVICE_TYPE.TABLET
				} else {
					state.deviceType = DEVICE_TYPE.DESKTOP
				}
			} else {
				state.deviceType = DEVICE_TYPE.MOBILE
			}
			// console.log('[resizeSlice] - windowResize: orientation =', state.orientation, 'deviceType =', state.deviceType)

			// Update variable used to force mobile layout at different screen sizes, allows for landscape tablets to display desktop
			if (state.deviceType === DEVICE_TYPE.DESKTOP) {
				state.useMobileLayout = false
			} else if (state.orientation === DEVICE_ORIENTATION.PORTRAITE) {
				state.useMobileLayout = true
			} else if (state.deviceType === DEVICE_TYPE.MOBILE) {
				state.useMobileLayout = true
			} else {
				state.useMobileLayout = false
			}
		}
	}
})

// Export actions
export const { windowResize } = resizeSlice.actions

// Export selectors
export const deviceType = (state: RootState) => state.resize.deviceType
export const orientation = (state: RootState) => state.resize.orientation
export const innerWidth = (state: RootState) => state.resize.innerWidth
export const innerHeight = (state: RootState) => state.resize.innerHeight
export const useMobileLayout = (state: RootState) => state.resize.useMobileLayout

// Export the reducer
export default resizeSlice.reducer
